<template>
  <svg
    v-if="direction === 'down' || direction === 'up'"
    viewBox="0 0 12 20"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    aria-hidden="true"
    focusable="false"
    class="bp-arrow-v"
    :style="direction === 'up' ? 'transform: scaleY(-1)' : undefined"
  >
    <path d="M6 0v18M1 13l5 5 5-5" />
  </svg>
  <svg
    v-else
    viewBox="0 0 28 12"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M0 6h26M21 1l5 5-5 5" />
  </svg>
</template>

<script setup lang="ts">
defineProps<{ direction?: 'right' | 'down' | 'up' }>()
</script>
